import {AnalyzeListElementType, AnalyzeListMapType, AnalyzeSearchParamType} from "../interface";
import moment from "moment";

export const analyzeSearchParamInit: AnalyzeSearchParamType = {
    endAt: moment().format("YYYY-MM-DD"),
    keyword: "",
    keywordType: "1",
    limit: 10,
    pageNo: 1,
    startAt: moment().startOf('year').format("YYYY-MM-DD"),
    stateOption: "0",
}

export const analyzeListElementInit: AnalyzeListElementType = {
    inventoryId: 0,
    vendor: "",
    category: "",
    newTxtNmItem: "",
    newTxtStndItem: "",
    inventoryUnit: 0,
    inventoryAmount: 0,
    totalIncomingAmount: 0,
    totalOutgoingAmount: 0,
    needToOrder: "",
    avgInventoryAmountInPeriod: 0,
    avgDailyIncoming: 0,
    avgDailyOutgoing: 0,
}

export const analyzeListMapInit: AnalyzeListMapType = {
    formulaList: [],
    inventoryAnalysisList: [],
    totalCount: 0,
}